export default __webpack_public_path__ + "static/media/FerrariF430.3106de40.jpg";